import { textOverflowEllipsis } from "@eisinc/App/SharedStyles/GeneralStyles";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Styling of Product Count in PLP
productCountStyles.wrapper = {
    css: css`
        margin-top: 0;
        padding-bottom: 16px;
        border-bottom: 1px solid ${getColor("common.ui2")};
    `,
};

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 32px;
        font-weight: 600;
    `,
};
productCountStyles.itemsText = {
    css: css`
        font-size: 20px;
        letter-spacing: 0;
        line-height: 32px;
    `,
};
productCountStyles.queryText = {
    css: css`
        font-size: 20px;
        letter-spacing: 0;
        line-height: 32px;
    `,
};
// // End Styling of Product Count in PLP

// Styling of Product sort Select in PLP
sortSelectStyles.select = {
    iconProps: {
        css: css`
            right: -2px !important;
        `,
    },
    labelProps: {
        css: css`
            padding-top: 0;
            padding-right: 10px;
            width: auto;
            font-weight: normal;
        `,
    },
    cssOverrides: {
        formField: css`
            display: flex;
            align-items: center;
            > div {
                margin-top: 0 !important;
                width: auto;
                flex: 1;

                select {
                    padding-right: 25px !important;
                    ${textOverflowEllipsis};
                }
            }
        `,
    },
};
// // End Styling of Product sort Select in PLP
